export const ENDUSER = {
  TYPE_OF_RESIDENCE_LIST: [
    { name: 'Duplex', value: 'duplex' },
    { name: 'Single Family', value: 'single family' },
    { name: 'Apartment', value: 'apartment' },
    { name: 'Condo', value: 'condo' },
    { name: 'RV/Trailer', value: 'rv_trailer' },
    { name: 'Land Plot Point', value: 'land_plot_point' },
  ],
  ENTRANCE_LOCATION_LIST: [
    { name: 'Front', value: 'front' },
    { name: 'Rear', value: 'rear' },
    { name: 'Side', value: 'side' },
  ],
  HOME_TYPE_LIST: [
    { name: 'Basement', value: 'basement' },
    { name: 'Attic', value: 'attic' },
    { name: 'Both', value: 'both' },
    { name: 'None', value: 'none' },
  ],
  LANGUAGE_LIST: [
    {
      name: 'Arabic',
      value: 'ARA',
    },
    {
      name: 'Bengali',
      value: 'BEN',
    },
    {
      name: 'Chinese',
      value: 'CHI',
    },
    {
      name: 'Dutch',
      value: 'DUT',
    },
    {
      name: 'English',
      value: 'ENG',
    },
    {
      name: 'Farsi',
      value: 'FAR',
    },
    {
      name: 'French',
      value: 'FRE',
    },
    {
      name: 'German',
      value: 'GER',
    },
    {
      name: 'Hebrew',
      value: 'HEB',
    },
    {
      name: 'Hindi',
      value: 'HIN',
    },
    {
      name: 'Italian',
      value: 'ITA',
    },
    {
      name: 'Japanese',
      value: 'JAP',
    },
    {
      name: 'Javanese',
      value: 'JAV',
    },
    {
      name: 'Korean',
      value: 'KOR',
    },
    {
      name: 'Panjabi',
      value: 'PAN',
    },
    {
      name: 'Persian',
      value: 'PER',
    },
    {
      name: 'Polish',
      value: 'POL',
    },
    {
      name: 'Portuguese',
      value: 'POR',
    },
    {
      name: 'Romanian',
      value: 'ROM',
    },
    {
      name: 'Russian',
      value: 'RUS',
    },
    {
      name: 'Serbo-Croatian',
      value: 'SER',
    },
    {
      name: 'Spanish',
      value: 'SPA',
    },
    {
      name: 'Tamil',
      value: 'TAM',
    },
    {
      name: 'Telugu',
      value: 'TEL',
    },
    {
      name: 'Turkish',
      value: 'TUR',
    },
    {
      name: 'Ukrainian',
      value: 'UKR',
    },
    {
      name: 'Urdu',
      value: 'URD',
    },
    {
      name: 'Vietnamese',
      value: 'VIE',
    },
  ],
  FORM_CONTROL: {
    DEMOGRAPHIC_DOB: 'demographic.dob',
    INFO_PERPETRATOR_DOB: 'info.perpetratorDob',
  },
};
